// extracted by mini-css-extract-plugin
export default {"login-wrapper-container":"Account_login-wrapper-container__0bY7T","up_note":"Account_up_note__Est2v","title":"Account_title__dN1nK","sub_title":"Account_sub_title__+aN70"};